import { SankeyLink as SankeyLinkType, sankeyLinkHorizontal } from 'd3-sankey';
import React from 'react';

export type LinkDataPoint = SankeyLinkType<any, any>;

const makeDPath = sankeyLinkHorizontal<any, any>();

interface SankeyLinkComponentProps {
  d: string;
  strokeWidth?: number;
  color?: string;
  title?: string;
  onMouseMove?: (e: MouseEvent) => void;
  onMouseEnter?: (e: MouseEvent) => void;
  onMouseOut?: (e: MouseEvent) => void;
}

export const SankeyLinkComponent = ({
  d,
  color,
  strokeWidth,
  title,
  ...events
}: SankeyLinkComponentProps): JSX.Element => {
  return (
    <g style={{ mixBlendMode: 'multiply' }}>
      <path d={d} stroke={color} opacity={0.45} strokeWidth={strokeWidth} {...events}>
        {title && <title>{title}</title>}
      </path>
    </g>
  );
};

interface SankeyLinksComponentProps {
  links: LinkDataPoint[];
  titleFunc?: (link: LinkDataPoint) => string;
  colorFunc?: (link: LinkDataPoint) => string;
  onMouseMove?: (e: MouseEvent, link: LinkDataPoint) => void;
  onMouseEnter?: (e: MouseEvent, link: LinkDataPoint) => void;
  onMouseOut?: (e: MouseEvent, link: LinkDataPoint) => void;
}

export const SankeyLinksComponent = ({
  links,
  titleFunc,
  colorFunc,
  onMouseMove,
  onMouseEnter,
  onMouseOut,
}: SankeyLinksComponentProps): JSX.Element => {
  return (
    <g fill="none" strokeOpacity={0.5}>
      {links.map((link) => {
        const d = makeDPath(link);

        if (!d) return null;

        const strokeWidth = Math.max(1, link.width || 0);

        const { source, target } = link;
        const key =
          (typeof source === 'object' ? source.id : source) +
          '--' +
          (typeof target === 'object' ? target.id : target);

        return (
          <SankeyLinkComponent
            key={key}
            d={d}
            color={colorFunc?.(link)}
            title={titleFunc?.(link)}
            strokeWidth={strokeWidth}
            onMouseMove={(e) => onMouseMove?.(e, link)}
            onMouseEnter={(e) => onMouseEnter?.(e, link)}
            onMouseOut={(e) => onMouseOut?.(e, link)}
          />
        );
      })}
    </g>
  );
};
